import { render, staticRenderFns } from "./EmulationProjectDetails.vue?vue&type=template&id=dd0a8d34&"
import script from "./EmulationProjectDetails.vue?vue&type=script&lang=ts&"
export * from "./EmulationProjectDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EmulationProjectDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports